import FindByReferralCode from "./FindByReferralCode";

const Referral = {
	FindByReferralCode
};

export default Referral;